module.exports = __webpack_public_path__ + "img/face45.4ac97da5.gif";